import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'switch-control',
    templateUrl: './switch-control.component.html',
    styleUrls: ['./switch-control.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SwitchControlComponent),
            multi: true
        }
    ]
})
export class SwitchControlComponent implements ControlValueAccessor {
    @Input() label: string = '';
    @Output() onChange = new EventEmitter<boolean>();
    isChecked: boolean = false;

    private onModelChange: (value: boolean) => void = () => {};
    private onModelTouched: () => void = () => {};

    writeValue(value: boolean): void {
        this.isChecked = value;
    }

    registerOnChange(fn: (value: boolean) => void): void {
        this.onModelChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onModelTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        // Optional: Handle disabled state if needed
    }

    onToggle(event: Event): void {
        this.isChecked = (event.target as HTMLInputElement).checked;
        this.onModelChange(this.isChecked);
        this.onModelTouched();
        this.onChange.emit(this.isChecked); // Emit the change event
    }
}
